import { Injectable } from '@angular/core';
import { TrimInspectionEnvService } from './trim-inspection-env.service';
import { HttpClient } from '@angular/common/http';
import {
  TGetAqlListingResponse,
  TGetAqlListingRequest,
  TTrimLotListingRequest,
  TTrimLotListingResponse,
  TStartOrUpdateTrimsLotInspectionRequest,
  TStartOrUpdateTrimsLotInspectionResponse,
  TSyncTrimsRollInspectionRequest,
  TSyncTrimsRollInspectionResponse,
  TCompleteTrimsInspectionResponse,
  TCompleteTrimsInspectionRequest,
  TRestartInspectionRequest,
  TRestartInspectionResponse,
  TGetLotDetailsResponse,
  TGetLotDetailsRequest,
  TfetchTrimsCountRequest,
  TTrimsCountResponse,
  TTrimgetLotDetailbyGrnTagRequest,
  TTrimgetLotDetailbyGrnTagResponse,
} from '@monorepo/types';

@Injectable({
  providedIn: 'root',
})
export class TrimInspectionDataService {
  constructor(private trimInspectionEnvService: TrimInspectionEnvService, private http: HttpClient) {}

  getTrimsLotListing(payload: TTrimLotListingRequest) {
    const url = this.trimInspectionEnvService.getEnvVar('TRIMS_LOT_LISTING');
    return this.http.post<TTrimLotListingResponse>(url, payload);
  }

  getAqlListing(payload: TGetAqlListingRequest) {
    const url = this.trimInspectionEnvService.getEnvVar('AQL_LISTING');
    return this.http.post<TGetAqlListingResponse>(url, payload);
  }

  startOrUpdateInspection(payload: TStartOrUpdateTrimsLotInspectionRequest) {
    const url = this.trimInspectionEnvService.getEnvVar('START_OR_UPDATE_INSPECTION');
    return this.http.post<TStartOrUpdateTrimsLotInspectionResponse>(url, payload);
  }

  syncInspection(payload: TSyncTrimsRollInspectionRequest) {
    const url = this.trimInspectionEnvService.getEnvVar('SYNC_INSPECTION');
    return this.http.post<TSyncTrimsRollInspectionResponse>(url, payload);
  }

  completeInspection(payload: TCompleteTrimsInspectionRequest) {
    const url = this.trimInspectionEnvService.getEnvVar('COMPLETE_INSPECTION');
    return this.http.post<TCompleteTrimsInspectionResponse>(url, payload);
  }

  restartInspection(payload: TRestartInspectionRequest) {
    const url = this.trimInspectionEnvService.getEnvVar('RESTART_INSPECTION');
    return this.http.post<TRestartInspectionResponse>(url, payload);
  }

  getLotDetails(payload: TGetLotDetailsRequest) {
    const url = this.trimInspectionEnvService.getEnvVar('GET_LOT_DETAILS');
    return this.http.post<TGetLotDetailsResponse>(url, payload);
  }

  fetchTrimsCount(payload: TfetchTrimsCountRequest) {
    const url = this.trimInspectionEnvService.getEnvVar('GET_TRIMS_COUNT');
    return this.http.post<TTrimsCountResponse>(url, payload);
  }

  getLotDetailsByGrnTag(payload: TTrimgetLotDetailbyGrnTagRequest) {
    const url = this.trimInspectionEnvService.getEnvVar('GET_LOT_DETAILS_BY_GRNTAG');
    return this.http.post<TTrimgetLotDetailbyGrnTagResponse>(url, payload);
  }
}
